module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Tag component is the internal tags used in the TagInput component</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Tag&gt;Tag Label&lt;/Tag&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Tag/README.md
// module id = 399
// module chunks = 0